<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <div
              class="d-flex align-items-center border bg-white rounded p-1 me-2"
            >
              <!-- <router-link

                to="/attendance/attendance-employee"
                class="btn btn-icon btn-sm me-1"
              >
                <i class="ti ti-brand-days-counter"></i>
              </router-link> -->
              <router-link
              v-if="!isEmployee"
                to="/attendance/attendance-admin"
                class="btn btn-icon btn-sm active bg-primary text-white"
              >
                <i class="ti ti-calendar-event"></i>
              </router-link>
            </div>
          </div>

          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                  @click.prevent="exportAttendance('pdf')"
                  v-can="'Reports.Export'"
                    ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                  @click.prevent="exportAttendance('csv')"
                  v-can="'Reports.Export'"
                    ><i class="ti ti-file-type-xls me-1"></i>Export as CSV</a
                  >
                </li>
              </ul>
            </div>
          </div>

          <!-- <div class="mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              data-bs-target="#attendance_report"
              data-bs-toggle="modal"
            >
              <i class="ti ti-file-analytics me-2"></i>Report
            </a>
          </div> -->

          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- KPIs -->
      <div class="card border-0">
        <div class="card-body">
          <div class="row align-items-center mb-4">
            <div class="col-md-5">
              <div class="mb-3 mb-md-0">
                <h4 class="mb-1">Attendance Details {{ kpiDateLabel }}</h4>
                <p class="mb-0">
                  <span v-if="adminAttendanceStore.loadingStats" class="text-muted"
                    >Loading summary…</span
                  >
                  <span v-else>
                    {{ totalEmployees }} active employees
                    <span v-if="filteredDateLabel" class="text-muted">
                      · {{ filteredDateLabel }}
                    </span>
                  </span>
                </p>
              </div>
            </div>
            <div class="col-md-7">
              <div class="d-flex align-items-center justify-content-md-end">
                <h6>{{ absenteeLabel }}</h6>
                <div class="avatar-list-stacked avatar-group-sm ms-4">
                  <a
                    class="avatar bg-primary avatar-rounded text-fixed-white fs-12"
                    href="javascript:void(0);"
                  >
                    +{{ kpiAbsent }}
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="border rounded">
            <div class="row gx-0">
              <div class="col-md col-sm-4 border-end">
                <div class="p-3">
                  <span class="fw-medium mb-1 d-block">Present</span>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <h5>{{ kpiPresent }}</h5>
                  </div>
                </div>
              </div>

              <div class="col-md col-sm-4 border-end">
                <div class="p-3">
                  <span class="fw-medium mb-1 d-block">Late Login</span>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <h5>{{ kpiLate }}</h5>
                  </div>
                </div>
              </div>

              <div class="col-md col-sm-4 border-end">
                <div class="p-3">
                  <span class="fw-medium mb-1 d-block">Uninformed</span>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <h5>{{ kpiUninformed }}</h5>
                  </div>
                </div>
              </div>

              <div class="col-md col-sm-4 border-end">
                <div class="p-3">
                  <span class="fw-medium mb-1 d-block">Permission</span>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <h5>{{ kpiPermission }}</h5>
                  </div>
                </div>
              </div>

              <div class="col-md col-sm-4">
                <div class="p-3">
                  <span class="fw-medium mb-1 d-block">Absent</span>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <h5>{{ kpiAbsent }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Admin table + filters -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Admin Attendance</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="me-3">
              <div class="input-icon w-120 position-relative">
                <span class="input-icon-addon"
                  ><i class="ti ti-calendar"></i
                ></span>
                <date-picker
                  ref="attendanceDateRef"
                  v-model="startdate"
                  class="form-control datetimepicker"
                  placeholder="dd/mm/yyyy"
                  :clearable="false"
                  :input-format="dateFormat"
                  @update:model-value="onAttendanceDatePicked"
                />
              </div>
            </div>

            <!-- Dynamic Department -->
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ departmentDropdownLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="applyDepartmentFilter(null)"
                    >All</a
                  >
                </li>
                <li v-for="d in departments" :key="d.id">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="applyDepartmentFilter(d)"
                  >
                    {{ d.name }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ statusDropdownLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="applyStatusFilter('Present')"
                    >Present</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="applyStatusFilter('Late')"
                    >Late</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="applyStatusFilter('Uninformed')"
                    >Uninformed</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="applyStatusFilter('Permission')"
                    >Permission</a
                  >
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="applyStatusFilter('')"
                    >Clear</a
                  >
                </li>
              </ul>
            </div>

            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ sortDropdownLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="sortBy('Recently Added')"
                    >Recently Added</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="sortBy('Ascending')"
                    >Ascending</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="sortBy('Descending')"
                    >Descending</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="sortBy('Last Month')"
                    >Last Month</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="sortBy('Last 7 Days')"
                    >Last 7 Days</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="sortBy('This Month')"
                    >This Month</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="sortBy('Last 30 Days')"
                    >Last 30 Days</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <attendence-admin-table @edit="openEdit" @delete="confirmDelete" />
          </div>
        </div>
        <div
          class="card-footer d-flex align-items-center justify-content-between flex-wrap gap-2"
        >
          <div class="text-muted">
            Showing page {{ store.pagination.current_page }} of {{ totalPages }}
            <span v-if="store.pagination.total">
              ({{ store.pagination.total }} records)
            </span>
          </div>
          <div class="d-flex gap-2">
            <button
              class="btn btn-outline-secondary btn-sm"
              :disabled="store.pagination.current_page <= 1 || store.loading"
              @click="goToPage(store.pagination.current_page - 1)"
            >
              Prev
            </button>
            <button
              class="btn btn-outline-secondary btn-sm"
              :disabled="store.pagination.current_page >= totalPages || store.loading"
              @click="goToPage(store.pagination.current_page + 1)"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuik Technological World</a
        >
      </p>
    </div>
  </div>

  <attendance-admin-edit-modal
    :record="editRecord"
    :delete-record="deleteRecord"
    @saved="onRecordSaved"
    @deleted="onRecordDeleted"
  />
</template>


<script setup>
import { ref, computed, onMounted, nextTick } from "vue";
import Modal from "bootstrap/js/dist/modal";
import AttendenceAdminTable from "./attendance-admin-table.vue";
import AttendanceAdminEditModal from "@/components/modal/attendance-admin-modal.vue";
import { useAttendanceEmployeeStore } from "@/stores/attendanceEmployeeStore";
import { useAdminAttendanceStore } from "@/stores/adminAttendanceStore";
import { useDepartmentStore } from "@/stores/departmentStore";
import { useAuthStore } from "@/stores/authStore";
import { formatAttendanceDate } from "@/utils/attendanceDateTime";


const store = useAttendanceEmployeeStore();
const adminAttendanceStore = useAdminAttendanceStore();
const auth = useAuthStore();
const deptStore = useDepartmentStore();

const title = ref("Attendance Admin");
const text = ref("HR");
const text1 = ref("Attendance Admin");

// date-picker
const startdate = ref(new Date());
const attendanceDateRef = ref(null);
const dateFormat = ref("dd-MM-yyyy");

// UI labels
const statusDropdownLabel = ref("Select Status");
const sortDropdownLabel = ref("Sort By : Today");
const departmentDropdownLabel = ref("Department");

const isEmployee = computed(() => auth.user?.roles.includes("Employee"))


// selected filters
const selectedDepartmentId = ref(null);
const editRecord = ref(null);
const deleteRecord = ref(null);

// departments (dynamic)
const departments = computed(() => deptStore.departments || []);

function ymd(d = new Date()) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;
}

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function currentAttendanceParams() {
  return {
    from: store.filters.date_from || store.filters.date || undefined,
    to: store.filters.date_to || store.filters.date || undefined,
    status: store.filters.status || undefined,
    department_id: selectedDepartmentId.value || undefined,
    search: store.filters.search || undefined,
    employee_id: store.filters.employee_id || undefined,
  };
}

async function exportAttendance(format) {
  const params = currentAttendanceParams();
  if (format === "pdf") {
    await store.exportAttendancePDF(params);
    return;
  }

  await store.exportAttendanceCSV(params);
}

/* ---------------- KPIs from BACKEND summary ---------------- */
const attendanceSummary = computed(() => adminAttendanceStore.stats || {});
const totalEmployees = computed(() =>
  Number(attendanceSummary.value.total_employees || 0)
);
const kpiPresent = computed(() => Number(attendanceSummary.value.present || 0));
const kpiAbsent = computed(() => Number(attendanceSummary.value.absent || 0));
const kpiLate = computed(() => Number(attendanceSummary.value.late || 0));
const kpiUninformed = computed(() =>
  Number(attendanceSummary.value.uninformed ?? attendanceSummary.value.absent ?? 0)
);
const kpiPermission = computed(() =>
  Number(attendanceSummary.value.permission ?? attendanceSummary.value.on_leave ?? 0)
);

const kpiDateLabel = computed(() => {
  if (store.filters.date_from && store.filters.date_to) return "for Selected Period";
  if (store.filters.date && store.filters.date !== ymd(new Date())) {
    return "for Selected Date";
  }
  return "Today";
});

const absenteeLabel = computed(() => {
  const today = ymd(new Date());
  if (!store.filters.date_from && !store.filters.date_to && store.filters.date === today) {
    return "Total absentees today";
  }
  if (store.filters.date_from && store.filters.date_to) {
    return "Total absentees in this period";
  }
  return "Total absentees";
});

const filteredDateLabel = computed(() => {
  if (store.filters.date_from && store.filters.date_to) {
    return `${formatAttendanceDate(store.filters.date_from)} – ${formatAttendanceDate(store.filters.date_to)}`;
  }
  if (store.filters.date) {
    return formatAttendanceDate(store.filters.date);
  }
  return "";
});

const totalPages = computed(() => {
  const total = store.pagination.total || 0;
  const perPage = store.pagination.per_page || 25;
  return Math.max(1, Math.ceil(total / perPage));
});

function listParams(extra = {}) {
  return {
    page: store.pagination.current_page,
    date: store.filters.date || undefined,
    date_from: store.filters.date_from || undefined,
    date_to: store.filters.date_to || undefined,
    status: store.filters.status || undefined,
    department_id: selectedDepartmentId.value || undefined,
    sort: store.filters.sort || undefined,
    ...extra,
  };
}

async function fetchRecords(extra = {}) {
  await store.fetchRecords(listParams(extra));
}

async function goToPage(page) {
  await fetchRecords({ page });
}

function openEdit(record) {
  editRecord.value = record;
  nextTick(() => {
    Modal.getOrCreateInstance(
      document.getElementById("edit_attendance_admin")
    )?.show();
  });
}

function confirmDelete(record) {
  const id = Number(record?.id);
  if (!Number.isFinite(id) || id <= 0) return;

  deleteRecord.value = record;
  nextTick(() => {
    Modal.getOrCreateInstance(
      document.getElementById("attendance_admin_delete_modal")
    )?.show();
  });
}

async function onRecordDeleted() {
  deleteRecord.value = null;
  await fetchRecords({ page: store.pagination.current_page });
  await refreshAdminStats();
  adminAttendanceStore.invalidateStats();
}

async function onRecordSaved() {
  await fetchRecords({ page: store.pagination.current_page });
  await refreshAdminStats();
  adminAttendanceStore.invalidateStats();
}

async function refreshAdminStats() {
  const params = {
    department_id: selectedDepartmentId.value || undefined,
    force: true,
  };

  if (store.filters.date_from && store.filters.date_to) {
    params.date_from = store.filters.date_from;
    params.date_to = store.filters.date_to;
  } else {
    params.date = store.filters.date || ymd(new Date());
  }

  await adminAttendanceStore.fetchStats(params);
}

function onAttendanceDatePicked(value) {
  // The picker stays focused after a choice, so the next click does not open it.
  nextTick(() => {
    attendanceDateRef.value?.$el?.querySelector("input")?.blur();
  });
  applyDateFilter(value);
}

/* ---------------- Filters ---------------- */
async function applyDateFilter(d) {
  // single-day mode – clear any date range first
  store.filters.date_from = "";
  store.filters.date_to = "";

  let value = "";
  try {
    const dt = d instanceof Date ? d : new Date(d);
    value = ymd(dt);
  } catch {}
  store.filters.date = value;

  await fetchRecords({ page: 1, date: value || undefined });
  await refreshAdminStats();
}

async function applyStatusFilter(value) {
  statusDropdownLabel.value = value || "Select Status";
  store.filters.status = value || "";

  await fetchRecords({ page: 1 });
  await refreshAdminStats();
}

async function applyDepartmentFilter(dep) {
  if (!dep) {
    selectedDepartmentId.value = null;
    departmentDropdownLabel.value = "Department";
  } else {
    selectedDepartmentId.value = dep.id;
    departmentDropdownLabel.value = dep.name || `Dept #${dep.id}`;
  }

  await fetchRecords({ page: 1 });
  await refreshAdminStats();
}

async function sortBy(range) {
  sortDropdownLabel.value = `Sort By : ${range}`;

  if (range === "Recently Added") {
    store.filters.sort = "recent";
    await fetchRecords({ page: 1 });
    return;
  }
  if (range === "Ascending") {
    store.filters.sort = "name_asc";
    await fetchRecords({ page: 1 });
    return;
  }
  if (range === "Descending") {
    store.filters.sort = "name_desc";
    await fetchRecords({ page: 1 });
    return;
  }

  store.filters.sort = "recent";
  // range mode – clear single-day filter first
  store.filters.date = "";

  const now = new Date();
  const to = ymd(now);

  const base = {
    page: 1,
    status: store.filters.status || undefined,
    department_id: selectedDepartmentId.value || undefined,
  };

  if (range === "Last 7 Days") {
    const d = new Date();
    d.setDate(d.getDate() - 6);
    store.filters.date_from = ymd(d);
    store.filters.date_to = to;
  } else if (range === "Last 30 Days") {
    const d = new Date();
    d.setDate(d.getDate() - 29);
    store.filters.date_from = ymd(d);
    store.filters.date_to = to;
  } else if (range === "Last Month") {
    const d1 = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const d2 = new Date(now.getFullYear(), now.getMonth(), 0);
    store.filters.date_from = ymd(d1);
    store.filters.date_to = ymd(d2);
  } else if (range === "This Month") {
    const d = new Date(now.getFullYear(), now.getMonth(), 1);
    store.filters.date_from = ymd(d);
    store.filters.date_to = to;
  } else {
    store.filters.date_from = "";
    store.filters.date_to = "";
    store.filters.date = ymd(new Date());
    await fetchRecords({ page: 1, date: store.filters.date });
    await refreshAdminStats();
    return;
  }

  await fetchRecords({
    page: 1,
    date_from: store.filters.date_from,
    date_to: store.filters.date_to,
  });
  await refreshAdminStats();
}

/* ---------------- Lifecycle ---------------- */
onMounted(async () => {
  document
    .getElementById("attendance_admin_delete_modal")
    ?.addEventListener("hidden.bs.modal", () => {
      deleteRecord.value = null;
    });

  // load departments
  try {
    if (typeof deptStore.fetchDepartments === "function") {
      await deptStore.fetchDepartments();
    }
  } catch {}

  // The date box already shows today. Apply that day to the list and the totals.
  store.filters.date_from = "";
  store.filters.date_to = "";
  store.filters.date = ymd(new Date());
  store.filters.sort = store.filters.sort || "recent";
  startdate.value = new Date();
  sortDropdownLabel.value = "Sort By : Today";
  await fetchRecords({ page: 1, date: store.filters.date });
  await refreshAdminStats();
});
</script>





